module.exports = __webpack_public_path__ + "static/media/web development.be26afaa.png";